var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { autobind } from 'core-decorators';
import React from 'react';
import { connect } from 'react-redux';
import { LoginForm } from '../../components/login-form/login-form';
import { getConfig } from '../../config';
import { getCurrentHost } from '../../utils/host/host';
import { sendLoginBiEvent } from './login.actions';
import styles from './login.scss';
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Login.prototype.goToGoogleAuthenticationPage = function () {
        window.location.href = getConfig().api.baseUrl + "/authentication/google/oauth2_login?redirect_url=" + getCurrentHost();
    };
    Login.prototype.onFormSubmit = function () {
        this.props
            .sendLoginBiEvent()
            .then(this.goToGoogleAuthenticationPage, this.goToGoogleAuthenticationPage);
    };
    Login.prototype.render = function () {
        return (React.createElement("div", { className: styles.loginContainer },
            React.createElement("div", null,
                React.createElement(LoginForm, { onClick: this.onFormSubmit }))));
    };
    __decorate([
        autobind
    ], Login.prototype, "onFormSubmit", null);
    return Login;
}(React.PureComponent));
export { Login };
var mapStateToProps = null;
var mapDispatchToProps = {
    sendLoginBiEvent: sendLoginBiEvent,
};
export var LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);
